import React, { useRef, useEffect, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { useFrame, useThree } from "@react-three/fiber";
import { a } from "@react-spring/three";
import * as THREE from "three";
import ModelScene from "../accests/3d/svetofor_n.glb";
import gsap from "gsap";

const Svetofor_n = (props) => {
  const { nodes, materials } = useGLTF(ModelScene);
  const [hovered, hover] = useState(false);

  const colorChange = async () => {
    let key = Object.keys(materials);
    if (props.fog && !hovered)
      key.forEach((element) => {
        if (element != "окна" && element != "выступы")
          gsap.to(materials[element].emissive, 0.3, {
            r: 0.5,
            g: 0.5,
            b: 0.5,
          });
      });
    else {
      key.forEach((element) => {
        if (element != "окна" && element != "выступы")
          gsap.to(materials[element].emissive, 0.3, {
            r: 0,
            g: 0,
            b: 0,
          });
      });
    }
  };
  useEffect(() => {
    colorChange();
  }, [props.fog]);
  const modelRef = useRef();
  return (
    <a.group
      {...props}
      ref={modelRef}
      
    >
      <group
        position={[-17.305, 0, 8.45]}
        rotation={[-Math.PI / 2, 0, -3.082]}
        scale={0.122}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023.geometry}
          material={materials.столб}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_1.geometry}
          material={materials["столб.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_2.geometry}
          material={materials.светофор}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_3.geometry}
          material={materials["светофор.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_4.geometry}
          material={materials["светофор.002"]}
        />
      </group>
      <group rotation={[-Math.PI / 2, 0, Math.PI / 2]} scale={0.122}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023.geometry}
          material={materials.столб}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_1.geometry}
          material={materials["столб.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_2.geometry}
          material={materials.светофор}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_3.geometry}
          material={materials["светофор.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_4.geometry}
          material={materials["светофор.002"]}
        />
      </group>
      <group
        position={[27.4, 0, -26.77]}
        rotation={[-Math.PI / 2, 0, -1.71]}
        scale={0.122}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023.geometry}
          material={materials.столб}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_1.geometry}
          material={materials["столб.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_2.geometry}
          material={materials.светофор}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_3.geometry}
          material={materials["светофор.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_4.geometry}
          material={materials["светофор.002"]}
        />
      </group>
      <group
        position={[25.397, 0, -7.748]}
        rotation={[-Math.PI / 2, 0, -1.71]}
        scale={0.122}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023.geometry}
          material={materials.столб}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_1.geometry}
          material={materials["столб.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_2.geometry}
          material={materials.светофор}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_3.geometry}
          material={materials["светофор.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_4.geometry}
          material={materials["светофор.002"]}
        />
      </group>
      <group
        position={[6.37, 0, -35.799]}
        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
        scale={0.122}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023.geometry}
          material={materials.столб}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_1.geometry}
          material={materials["столб.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_2.geometry}
          material={materials.светофор}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_3.geometry}
          material={materials["светофор.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle023_4.geometry}
          material={materials["светофор.002"]}
        />
      </group>
    </a.group>
  );
};

export default Svetofor_n;
